export default __webpack_public_path__ + "static/christ-the-redeemer-7eb3051eb1adf8fad385fe46a58745bc.jpg";